import React, { useEffect } from 'react'

// import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import Grid from '@config/Grid/Grid'
import styles from './PageLayout.module.scss'

type PageLayoutProps = {
  children: React.ReactNode
}

function PublicPageLayout({ children }: PageLayoutProps) {
  const [imageTileHeight, setImageTileHeight] = React.useState(0)
  const location = useLocation()

  // const currentPage = location.pathname.split('/')[1]
  // const currentPathLength = location.pathname.split('/').length

  // const { t } = useTranslation()

  useEffect(() => {
    const formTileContainer =
      window.document.getElementById('formTileContainer')
    const formTileContainerHeight = formTileContainer?.clientHeight
    if (formTileContainerHeight) {
      setImageTileHeight(formTileContainerHeight)
    }
  }, [imageTileHeight, location.pathname])
  return (
    <Grid>
      <div className={`start-1 col-12 align-center ${styles.publicPageLayout}`}>
        <div id="formTileContainer" className={`${styles.formTileContainer}`}>
          {children}
        </div>
      </div>
    </Grid>
  )
}

export default PublicPageLayout
